import { Component, model } from '@angular/core';
import { InputComponent } from '@shared/components';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputModes, InputTypes } from '@core/enums';
import { ButtonComponent } from '@shared/components/button/button.component';
import { Events } from '@core/interfaces';

@Component({
  selector: 'ncp-default-search',
  imports: [InputComponent, ReactiveFormsModule, ButtonComponent],
  templateUrl: './default-search.component.html',
  styleUrl: './default-search.component.scss',
})
export class DefaultSearchComponent {
  protected readonly InputTypes = InputTypes;

  protected data = model<any>();

  private _params = {};

  protected formGroup: FormGroup = new FormGroup({
    search: new FormControl<string>(''),
  });

  get search() {
    return this.formGroup.get('search') as FormControl;
  }

  get params() {
    return this._params;
  }

  set params(params: {}) {
    this._params = params;
    if (this.data()?.setPaginationState) {
      this.data()?.setPaginationState?.(this.params);
    }
  }

  protected onKeyUp = (event: KeyboardEvent, value: string) => {
    this._params = { searchTerm: value, pageNumber: 1 };
    if (event.key === 'Enter' && event.code === 'Enter') {
      this.params = this._params;
    }
  };

  protected onBlur = (value: string): void => {
    this._params = { searchTerm: value, pageNumber: 1 };
    //this.params = this._params;
  };

  protected onClick = (event: PointerEvent): void => {
    if (event.pointerType !== '') {
      this.params = this._params;
    }
  };

  protected readonly InputModes = InputModes;
}
